import localStorage from 'localStorage';
import type { TableColumnConfig } from '../types/columnConfigTypes';

function getLocalStorageConfig(tableName: string): TableColumnConfig[] | null {
  return localStorage.get<TableColumnConfig[]>(tableName);
}

export default getLocalStorageConfig;
